import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ConfCallController } from './conf-call.controller';
import { ConfCallEntity } from './conf-call.entity';
import { ConfCallService } from './conf-call.service';
import { ConfGuestEntity } from './conf-guests.entity';

@Module({
    imports: [
        TypeOrmModule.forFeature([ConfCallEntity,ConfGuestEntity])
    ],
    controllers:[ConfCallController],
    providers:[ConfCallService],
    exports:[ConfCallService],
})
export class ConfCallModule {}

